import React, { useEffect, useState } from 'react'
import './UserBudgetBlock.scss'
import { connect } from 'react-redux'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Paper from '@material-ui/core/Paper';
import moment from 'moment'
import { DeleteIcon, DeromaLogo, EyeIcon, ScheurichLogo } from '../utils/icons'
import OldBudgetSummary from './OldBudgetSummary';
import { useActiveDesactiveSrollBody } from '../hooks/activeDesactivScrollBody';
import * as _ from 'lodash'
import PopupTwoButtons from './PopupTwoButtons';
import { tokerUser } from '../hooks/user';
import axios from 'axios'
import { showPopup } from '../actions'
import { APIS } from '../hooks/config';

const UserBudgetsBlock = (props) => {
    const { title, budgets, textButtonAdd, marca } = props
    const [budgetSelected, setBudgetSelected] = useState(null)
    const [directionOrder, setDirectionOrder] = useState(false)
    const [totalBudgets, setTotalBudgets] = useState(null)
    const [tempBudgets, setTempBudgets] = useState([])
    const [cartDeleteShowConfirm, setCartDeleteShowConfirm] = useState(false)
    const [cartDeleteData, setCartDeleteData] = useState(null)
    const [brandCartDelete, setBrandCartDelete] = useState(null)

    useEffect(() => {
        setTempBudgets(budgets)
        setTotalBudgets(budgets)
    }, [budgets])

    useEffect(() => {
    }, [tempBudgets])

    const handleSort = (property) => (event) => {
        const budgetsClon = _.cloneDeep(tempBudgets)
        const order = directionOrder ? 'asc' : 'desc'
        const budgetsOrder = _.orderBy(budgetsClon, [property], order)
        tempBudgets(budgetsOrder)
        setDirectionOrder(!directionOrder)
    }

    const handleSortDate = (property) => (event) => {
        const budgetsClon = _.cloneDeep(tempBudgets)
        const order = directionOrder ? 'asc' : 'desc'
        const budgetsOrder = _.orderBy(budgetsClon, budget => {
            return moment(budget.date, 'DD/MM/YYYY')
        }, order)
        tempBudgets(budgetsOrder)
        setDirectionOrder(!directionOrder)
    }

    const handleClickBudgetSelect = (budget, marca='fansa') => {
        setBudgetSelected(budget)
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useActiveDesactiveSrollBody(true)
    }

    const handleClickBudgetSelectClose = () => {
        setBudgetSelected(null)
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useActiveDesactiveSrollBody(false)
    }

    const handleClickShowCartsDeleteMessage = (budget) => {
        setCartDeleteData(budget)
        setCartDeleteShowConfirm(true)
        // setBrandCartDelete(marca)
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useActiveDesactiveSrollBody(true)
    }

    const handleClickCloseCartsDeleteMessage = () => {
        setCartDeleteData(null)
        setCartDeleteShowConfirm(false)
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useActiveDesactiveSrollBody(false)
    }

    const handleClickCartsDelete = () => {
        tokerUser().then(res => {
            const headers = {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${res}`
                }
            };
            const api = APIS[cartDeleteData.marca]
            axios.post(`${api}/protected/carts-delete`, {
                id: cartDeleteData.id,
                company: cartDeleteData.empresa,
                cif: cartDeleteData.cif,
                name: cartDeleteData.name,
                phonenumber: cartDeleteData.phonenumber,
                zone: cartDeleteData.zone,
                email: cartDeleteData.email,
                role: cartDeleteData.role,
                products: JSON.stringify(cartDeleteData.products)
            }, headers).then(res => {
                let budgets = _.cloneDeep(tempBudgets)
                const indexCart = _.findIndex(budgets, ['id', cartDeleteData.id])
                budgets.splice(indexCart, 1);
                setTempBudgets(budgets)
                setCartDeleteShowConfirm(false)
                // eslint-disable-next-line react-hooks/rules-of-hooks
                useActiveDesactiveSrollBody(false)
                setCartDeleteData(null)
                props.showPopup({ active: true, message: 'Presupuesto borrado', type: 'success' })
            }).catch(err => {
                props.showPopup({ active: true, message: 'Error al borrar', type: 'error' })
            })
        })
    }

    const handleChange = (event) => {
        const { value } = event.target;
        const budgetFilter = _.filter(budgets, budget => {
            return budget.location.toLowerCase().indexOf(value.toLowerCase()) > -1
        })
        if (value !== '' && value !== undefined && value !== null) {
            setTempBudgets(budgetFilter)
        } else {
            setTempBudgets(totalBudgets)
        }
    }

    return (
        <div className="user-budget-block-container">
            {budgetSelected !== null &&
                <OldBudgetSummary budgetSelected={budgetSelected} clickClose={handleClickBudgetSelectClose} textButtonAdd={textButtonAdd} />
            }
            {cartDeleteShowConfirm === true &&
                <PopupTwoButtons title="Confirmar borrado" text={"Desea borrar el presupuesto " + cartDeleteData.id} btnCancel="Cancelar" btnConfirm="Confirmar" clickClose={handleClickCloseCartsDeleteMessage} clickConfirm={handleClickCartsDelete} />
            }
            <div className="title">
                <p>
                  {marca !== 'scheurich' &&
                    title
                  }
                </p>
                <div className="filter">
                    <div className="search-input">
                        <div className="icon">
                            <i className="material-icons">search</i>
                        </div>
                        <div className="input-block">
                            <div className="input">
                                <input type="text" onChange={handleChange} placeholder="Centro" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="brand-chosen-banner">
                <div className="img">
                  {marca == 'scheurich' &&
                    <ScheurichLogo size={75} />
                  }
                  {marca == 'fansa' &&
                    <DeromaLogo size={75} />
                  }
                </div>
            </div>

            <TableContainer component={Paper}>
                <Table aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell className="id">
                                <TableSortLabel
                                    onClick={handleSort('id')}
                                >NÚM.</TableSortLabel>
                            </TableCell>
                            <TableCell className="company">
                                <TableSortLabel
                                    onClick={handleSort('company')}
                                >CLIENTE</TableSortLabel>
                            </TableCell>
                            <TableCell className="location">
                                <TableSortLabel
                                    onClick={handleSort('location')}
                                >CENTRO</TableSortLabel>
                            </TableCell>
                            <TableCell className="date">
                                <TableSortLabel
                                    onClick={handleSortDate('date')}
                                >FECHA</TableSortLabel>
                            </TableCell>
                            <TableCell className="show" align="center"></TableCell>
                            {(title === 'Presupuestos guardados' || title === '') &&
                                <TableCell className="delete" align="center"></TableCell>
                            }
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {tempBudgets !== null && tempBudgets.map((budget, index) => (
                            <TableRow key={index}>
                                <TableCell className="id" onClick={() => handleClickBudgetSelect(budget)} >{budget.id}</TableCell>
                                <TableCell className="company" onClick={() => handleClickBudgetSelect(budget)}>{budget.company}</TableCell>
                                <TableCell className="location" onClick={() => handleClickBudgetSelect(budget)}>{budget.location}</TableCell>
                                <TableCell className="date" onClick={() => handleClickBudgetSelect(budget)}>{budget.date}</TableCell>
                                <TableCell className="show pointer" onClick={() => handleClickBudgetSelect(budget)} align="center">
                                  <div className={`icon-color-fansa`}>
                                    <EyeIcon size={25} />
                                  </div>
                                  </TableCell>
                                {(title === 'Presupuestos guardados') &&
                                    <TableCell className="delete pointer" onClick={() => handleClickShowCartsDeleteMessage(budget)}>
                                      <div className={`icon-color-fansa`}>
                                        <DeleteIcon size={22} />
                                      </div>
                                    </TableCell>
                                }
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            {tempBudgets !== null && tempBudgets.length == 0 && 
                <p className="no-hay-presupuestos">No hay presupuestos</p>
            }
        </div>
    )
}

const mapDispatchToProps = {
    showPopup
}

export default connect(null, mapDispatchToProps)(UserBudgetsBlock)